module.exports = __webpack_public_path__ + "static/5-a66c67792c9b9f5e64982d4f48584b55.jpg";